<template>
  <div class="page_ blue_">
    <div class="steps">
      <span class="left">{{ $t("claimDetails[0]") || "直付" }}</span>
      <span class="no"
        >{{ $t("preAuth.serNum1") }}：{{ detailInfo.approval_code }}</span
      >
      <span>
        <img class="cicle" src="../assets/medilinkPC/cicle.png" alt="" />
        <span>{{ detailInfo.claims_progress }}</span>
      </span>
      <div class="change_account">
        <span @click="goDetail(detailInfo.claims_id)">
          {{ $i18n.locale == "zh-cn" ? "意见评估" : "Assessment" }}
        </span>
        <span v-if="payState === '1'" @click="handleToPay">
          {{ $i18n.locale == "zh-cn" ? "去支付" : "Pay" }}</span
        >
      </div>
    </div>
    <div class="step_2">
      <div class="top_" style="padding-left:29px;padding-right:29px;">
        <a-row>
          <a-col :span="6">
            {{ $t("InsuranceInfo[1]") || "保单号" }}：{{ detailInfo.policyNo }}
          </a-col>
          <a-col :span="6">
            {{ $t("preAuth.serCard") }}：{{ detailInfo.cardNo }}
          </a-col>
          <a-col :span="6">
            {{ $t("claim[6]") || "出险人" }}：{{ detailInfo.patient_name }}
          </a-col>
          <a-col :span="6">
            {{ $t("claim[7]") || "生效日期" }}：{{
              detailInfo.startDate != "" && detailInfo.startDate != null
                ? detailInfo.startDate.split("-").join("/")
                : "--"
            }}-{{
              detailInfo.endDate != "" && detailInfo.endDate != null
                ? detailInfo.endDate.split("-").join("/")
                : "--"
            }}
          </a-col>
        </a-row>
      </div>
      <div class="top_" style="padding:30px 29px">
        <a-row>
          <a-col :span="6">
            {{ $t("claim[11]") || "医疗机构" }}：{{ detailInfo.provider_name }}
          </a-col>
          <a-col :span="6">
            {{ $t("claim[13]") || "就诊日期" }}：{{
              detailInfo.admission_date
                ? detailInfo.admission_date.substring(0, 10)
                : ""
            }}
          </a-col>
          <a-col :span="6">
            {{ $t("claimDetails[29]") || "诊断" }}：{{
              detailInfo.primary_diagnosis
            }}
          </a-col>
        </a-row>
      </div>
      <div class="top_" style="padding:30px 29px">
        <a-row>
          <a-col :span="6">
            {{ $t("unpaid.totalMoney") }}：{{
              $i18n.locale == "zh-cn" ? "" : "￥"
            }}{{ detailInfo.due_total
            }}{{ $i18n.locale == "zh-cn" ? "元" : "" }}
          </a-col>
          <a-col :span="6">
            {{ $t("unpaid.payMoney") }}：{{ $i18n.locale == "zh-cn" ? "" : "￥"
            }}{{ detailInfo.paid_to_claiman
            }}{{ $i18n.locale == "zh-cn" ? "元" : "" }}
          </a-col>
          <a-col :span="6">
            {{ $t("unpaid.personMoney") }}：{{
              $i18n.locale == "zh-cn" ? "" : "￥"
            }}{{ detailInfo.paid_by_claimant
            }}{{ $i18n.locale == "zh-cn" ? "元" : "" }}
          </a-col>
          <a-col :span="6">
            {{ $t("unpaid.waitPay") }}：{{ $i18n.locale == "zh-cn" ? "" : "￥"
            }}{{ detailInfo.selfpaid_balance
            }}{{ $i18n.locale == "zh-cn" ? "元" : "" }}
          </a-col>
        </a-row>
      </div>
      <a-row type="flex" justify="end" style="margin-top: 20px;">
        <a-button
          ghost
          type="primary"
          style="margin-right: 20px;width: 127px;height:40px;border-color:#2c5acc;color:#2c5acc;border-radius:2px;"
          @click="back()"
          >{{ $t("claimDetails[4]") || "返回" }}</a-button
        >
      </a-row>
    </div>
  </div>
</template>

<style lang="scss" scoped>
p {
  margin: 0;
  padding: 0;
}
.page_ {
  // background-color: #fff;
  width: 100%;
  height: 100%;
  // padding: 17px 27px 0 27px;
  border-radius: 10px;
  color: #394155;
  padding-bottom: 20px;
  .steps {
    position: relative;
    background-color: #fff;
    height: 55px;
    line-height: 55px;
    width: 100%;
    font-size: 16px;
    // color: #cccccc;
    border-bottom: 1px #f3f3f3 solid;
    .left {
      margin-left: 29px;
      // display: inline-block;
      // width: 43px;
      // height: 21px;
      padding: 1px 5px;
      border: 1px #2c5acc solid;
      margin-right: 20px;
      text-align: center;
      color: #2c5acc;
      border-radius: 3px;
      font-size: 10px;
    }
    .cicle {
      width: 10px;
      height: 10px;
      margin-bottom: 5px;
      margin-left: 130px;
    }
    .no {
      font-size: 16px;
      font-weight: 500;
    }
    .change_account {
      color: #2c5acc;
      position: absolute;
      top: 12px;
      right: 30px;
      display: flex;
      span {
        height: 30px;
        line-height: 30px;
        display: inline-block;
        padding: 0 15px;
        margin-left: 10px;
        cursor: pointer;
        &:hover {
          font-weight: bold;
        }
      }
    }
    .cancel_apply {
      color: #2c5acc;
      position: absolute;
      top: 0;
      right: 30px;
    }
    .step_item {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      img {
        width: 17px;
        height: 17px;
      }
      .arrow_ {
        position: absolute;
        right: 0;
        font-size: 20px;
        color: #cccccc;
      }
      .arrow_blue {
        color: #2c5acc;
      }
    }
    .blue {
      border-bottom: 3px #2c5acc solid;
      color: #2c5acc;
    }
    .arrow_blue {
      color: #2c5acc;
    }
  }
  .step_1 {
    background-color: #fff;
    padding-top: 167px;
    padding-left: 336px;
    line-height: 24px;
    .attention_ {
      font-size: 16px;
      font-weight: 500;
      margin-bottom: 14px;
    }
    .next_ {
      margin-top: 38px;
    }
  }
  .step_2 {
    // background-color: #fff;
    // height: 144px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    .top_ {
      padding: 38px 0 38px;
      background-color: #fff;
      // height: 154px;
      margin-bottom: 20px;
    }
    .card_ {
      width: 100%;
      height: 560px;
      border-radius: 10px;
      background-color: #fff;
      padding: 27px 29px 0 29px;
      .account_ {
        margin-top: 16px;
        margin-bottom: 17px;
        position: relative;
        padding-left: 16px;
        // &::before {
        //   position: absolute;
        //   content: '';
        //   display: block;
        //   width: 7px;
        //   height: 7px;
        //   border-radius: 50%;
        //   background-color: #2C5ACC;
        // }
        // .text_ {
        .arrow_ {
          &::after {
            content: "";
            display: block;
            height: 0;
            width: 0;
            position: absolute;
            top: 7px;
            left: 0;
            border: 5px solid;
            border-color: #2c5acc transparent transparent transparent;
          }
          &.right_::after {
            top: 5px;
            //   border-color: transparent #4d4d4d transparent transparent;
          }
        }
        // }
      }
      .add_ {
        margin-top: 20px;
        margin-bottom: 30px;
      }
      .foot_ {
        margin-top: 20px;
        padding-top: 17px;
        border-top: 1px #e7e7e7 solid;
        position: relative;
        &::after {
          content: "";
          display: block;
          height: 0;
          width: 0;
          position: absolute;
          top: 20px;
          left: 0;
          border: 5px solid;
          border-color: transparent transparent transparent #2c5acc;
        }
        &.right_::after {
          top: 5px;
          //   border-color: transparent #4d4d4d transparent transparent;
        }
      }
      .card_info {
        margin-right: 22px;
      }
      .card_1 {
        color: #2c5acc;
        margin-top: 20px;
        width: 144px;
        height: 30px;
        line-height: 30px;
        border-left: 3px #2c5acc solid;
        background: #fafafa;
        text-align: center;
        margin-bottom: 20px;
        font-weight: 500;
      }
      .modify_info {
        .mr_ {
          margin-right: 8px;
        }
      }
    }
    .bottom_ {
      height: 177px;
      width: 100%;
      border-radius: 10px;
      background-color: #fff;
      margin-top: 20px;
      padding: 26px 29px 35px 29px;
      .remark_ {
        font-weight: 500;
        font-size: 16px;
      }
    }
    .tables_ {
      width: 100%;
      background-color: #fff;
      padding: 27px 29px 0 29px;
      border-radius: 10px;
      .tit_ {
        font-size: 16px;
        font-weight: 500;
        margin-bottom: 25px;
      }
      .h_50 {
        span {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .img_ {
        width: 10px;
        height: 10px;
        margin-right: 5px;
        min-width: 10px;
        margin-top: 5px;
      }
      .mt_20 {
        margin-top: 5px;
      }
      .mt_10 {
        margin-top: 10px;
      }
    }
  }
  .step_3 {
    color: #394155;
    padding-top: 27px;
    // padding: 27px 59px 0 61px;
    background-color: #fff;
    .cicle {
      width: 10px;
      height: 10px;
    }
    .tit {
      font-weight: 500;
    }
    .dec {
      margin-left: 10px;
      color: #999999;
    }
    .exp {
      margin-left: 10px;
    }
    .mt_ {
      margin-top: 10px;
    }
    .addlist {
      width: 100%;
      height: 150px;
      overflow-y: auto;
      border: 1px solid #ccc;
      border-radius: 4px;
      margin-top: 16px;
      input {
        outline: none;
        border: none;
        margin: 20px;
        width: 90%;
      }
      .list-item {
        .remove {
          margin-left: 10px;
          color: #e5002d;
          font-size: 18px;
        }
        .blue {
          margin-right: 5px;
        }
        display: flex;
        align-items: center;
        margin: 10px;
      }
    }
  }
}
</style>

<script>
import api from "@/utils/api";

export default {
  data() {
    return {
      claims_id: this.$route.params.claims_id,
      payState: this.$route.params.payState,
      detailInfo: {},
      statusOptionsclaim: [
        {
          value: "39",
          text: "Cancelled "
        },
        {
          value: "10",
          text: "Image upload failed"
        },
        {
          value: "20",
          text: "Image upload failed"
        },
        {
          value: "30",
          text: "Claims materials to be reviewed"
        },
        {
          value: "40",
          text: "Material review,file case"
        },
        {
          value: "50",
          text: "Claim materials failed to pass the review"
        },
        {
          value: "05",
          text: "Under Reviewing "
        },
        {
          value: "07",
          text: "Additional Information Requested"
        },
        {
          value: "06",
          text: "Apply Approval by Fronting Comp"
        },
        {
          value: "08",
          text: "Adjudication Completed"
        },
        {
          value: "09",
          text: "Finalized"
        },
        {
          value: "10",
          text: "Payment Processing"
        },
        {
          value: "11",
          text: "Paid"
        },
        {
          value: "12",
          text: "Pending"
        },
        {
          value: "13",
          text: "Canceled"
        }
      ]
    };
  },
  filters: {
    filterStatusClaim: (val, statusOptionsclaim) => {
      console.log(val, "val");
      if (val === "" || val === null || val === undefined) {
        return "--";
      } else {
        let textCon = "";
        statusOptionsclaim.map(item => {
          if (item.value == val) {
            textCon = item.text;
          }
        });
        return textCon;
      }
    }
  },
  mounted() {
    let lang = localStorage.getItem("lang");
    this.language = lang == "en-us" ? "ENGLISH" : "CHINAESE";
    this.fetchData();
  },
  methods: {
    fetchData() {
      api.getClaimsDetail({ claims_id: this.claims_id }).then(res => {
        if (res.data.code === 200 || res.data.data != null) {
          this.detailInfo = res.data.data;
        }
      });
    },
    goDetail(id) {
      api.genEOB({ claims_id: this.claims_id }).then(res => {
        if (res.data.code === 200) {
          window.location.href = res.data.data.url;
        }
      });
    },
    back() {
      this.$router.go(-1);
    },
    handleToPay() {
      let memberNo = localStorage.getItem("memberNo");
      let claims = [];
      let param = {
        memberNo: memberNo,
        claims: this.claims_id,
        payAmount: this.detailInfo.selfpaid_balance.replace(/,/g, ""),
        language: this.language
      };
      api
        .payinfo(param)
        .then(res => res.data)
        .then(data => {
          window.location.href = data.content;
        });
    }
  }
};
</script>
